module.exports = "/images/Fun Center.svg?9fefe1e012dab6ea1bc2f6c5487a53ff";